import React, { useEffect, useState } from "react";
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from "../layouts/TagInputs";
import PlaceOrder from "./PlaceOrderModal";
import { post, put } from "../../utility/fetch";
import notification from "../../utility/notification";
import SpeechToTextButton from "../UI/SpeechToTextButton";
import TextPrediction from "../layouts/TextPrediction";
import { Checkbox, FormControlLabel } from "@mui/material";
import { green } from "@mui/material/colors";

function LabServiceModal({ closeModal, editDetails, getInternalLabService, referralInfo }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [payload, setPayload] = useState({});
    const [loading, setLoading] = useState(false)

    const isMobile = window.innerWidth < 768;

    const openModal = () => {
        setIsModalOpen(true);
    };

    const close = () => {
        setIsModalOpen(false);
    };

    const createLabService = async () => {
        setLoading(true)
        let res;

        if (editDetails) {
            res = await put(`/internallabservice/${editDetails?.id}`, payload);
        }
        else {
            res = await post('/internallabservice/create-internal-lab-service', {
                ...payload,
                labServiceTestDetails: []
            });
        }


        console.log(res);
        if (res.statusCode === 200) {
            getInternalLabService();
            closeModal();
            notification({ message: res?.data?.message, type: "success" });
            setLoading(false)
            // fetchData();
            // next();
        } else {
            // Handle error
            setLoading(false)

        }
        setLoading(false)
    }

    const onTranscript = (transcript) => {
        setPayload((prev) => ({
            ...prev,
            description: payload?.description + " " + transcript
        }));
    }

    const handleChange = (e) => {
        if (e.target.name === "cost") {
            setPayload({ ...payload, [e.target.name]: Number(e.target.value) });
        }
        else {
            // update payload with form values
            setPayload({ ...payload, [e.target.name]: e.target.value });
        }

    }

    useEffect(() => {
        if (editDetails) {
            setPayload({
                name: editDetails?.name,
                cost: editDetails?.cost,
                description: editDetails?.description,
            })
        }
    }, [])


    return (
        <div className="overlay ">
            <RiCloseFill className='close-btn pointer' onClick={closeModal} />
            <div className="modal-content w-40" style={isMobile ? { width: '90%' } : {}}>
                <div className="  flex flex-direction-v flex-h-center">
                    <h2>Create Lab Service</h2>
                    <div className=" tabs m-t-10 bold-text"></div>
                    {/* <div className="col-6"> */}
                    <TagInputs value={payload?.name} onChange={handleChange} name="name" label="Lab Service Name" />
                    {/* </div> */}

                    {/* <div className="col-6"> */}
                    <TagInputs value={payload?.cost} type="number" onChange={handleChange} name="cost" label='Cost' />
                    {/* </div> */}
                    <div className="w-100 m-t-10">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    sx={
                                        {
                                            color: green[800],
                                            '&.Mui-checked': {
                                                color: green[600],
                                            },
                                        }
                                    }

                                    name="isFreeLabService"
                                    checked={payload?.isFreeLabService || false}
                                />
                            }
                            label="Is this a Free Service?"
                            name="isFreeLabService"
                            checked={payload?.isFreeLabService || false}
                            onChange={(e) =>
                                setPayload((prev) => ({
                                    ...prev,
                                    isFreeLabService: e.target.checked,
                                }))
                            }
                        />
                    </div>

                    {/* <div className="col-6"> */}
                    {/* <TagInputs value={payload?.description} onChange={handleChange} name="description" type='textArea' label='Description' /> */}
                    {/* </div> */}

                    <TextPrediction value={payload?.description} handleChange={handleChange} name="description" type='textArea' label='Description' />

                    <SpeechToTextButton onTranscript={onTranscript} />
                    <button disabled={loading} onClick={createLabService} className="submit-btn m-t-20"> {`${editDetails ? "Update" : "Create"} Lab Service`}</button>
                </div>

            </div>

        </div>
    );
}

export default LabServiceModal;